import { render, staticRenderFns } from "./TableDoctorForm.vue?vue&type=template&id=41610df3&scoped=true&"
import script from "./TableDoctorForm.vue?vue&type=script&lang=ts&"
export * from "./TableDoctorForm.vue?vue&type=script&lang=ts&"
import style0 from "./TableDoctorForm.vue?vue&type=style&index=0&id=41610df3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41610df3",
  null
  
)

export default component.exports